"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pickersFadeTransitionGroupClasses = exports.getPickersFadeTransitionGroupUtilityClass = void 0;
var _utils = require("@mui/utils");
const getPickersFadeTransitionGroupUtilityClass = slot => (0, _utils.unstable_generateUtilityClass)('MuiPickersFadeTransitionGroup', slot);
exports.getPickersFadeTransitionGroupUtilityClass = getPickersFadeTransitionGroupUtilityClass;
const pickersFadeTransitionGroupClasses = exports.pickersFadeTransitionGroupClasses = (0, _utils.unstable_generateUtilityClasses)('MuiPickersFadeTransitionGroup', ['root']);